import { render, staticRenderFns } from "./work.vue?vue&type=template&id=7010fba0&scoped=true&"
import script from "./work.vue?vue&type=script&lang=js&"
export * from "./work.vue?vue&type=script&lang=js&"
import style0 from "./work.vue?vue&type=style&index=0&id=7010fba0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7010fba0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Comment: require('/var/jenkins_home/workspace/prod-web-xfans/components/comment.vue').default})
